import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html {
    height: 100%;
    font-size: 14px;
  }

  body, #root {
    width: 100%;
    height: 100vh;
    font-family: Montserrat, Sans-serif;
    font-weight: 400;
    color: #495057;
    min-height: 100%;
    background: rgb(255, 255, 255);
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  
  .ToastContainer{
    position: absolute;
    white-space: break-spaces;
    min-width: 360px;
    z-index: 999;
    overflow: hidden;
  }


  .scroll-custom{
    overflow: auto;
    &::-webkit-scrollbar {
      width: 4px;
    }
    &::-webkit-scrollbar-thumb {
      background: #1D86FF;
      border-radius: 4px;
    }
  }
`;
